"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizing5xlarge = exports.sizing4xlarge = exports.sizing3xlarge = exports.sizing2xlarge = exports.sizingXlarge = exports.sizingLarge = exports.sizingMedium = exports.sizingSmall = exports.sizingXsmall = exports.sizingTiny = exports.sizingMini = exports.controlSizingLarge = exports.controlSizingMedium = exports.controlSizingSmall = exports.controlSizingXsmall = exports.controlSizingTiny = exports.controlSizingMini = exports.actionSizingLarge = exports.actionSizingMedium = exports.actionSizingSmall = exports.actionSizingXsmall = exports.actionSizingTiny = exports.actionSizingMini = exports.baseSizing2xlarge = exports.baseSizingXlarge = exports.baseSizingLarge = exports.baseSizingMedium = exports.baseSizingSmall = exports.baseSizingXsmall = exports.baseSizingTiny = exports.baseSizingMini = void 0;
exports.baseSizingMini = 12;
exports.baseSizingTiny = 16;
exports.baseSizingXsmall = 20;
exports.baseSizingSmall = 24;
exports.baseSizingMedium = 32;
exports.baseSizingLarge = 48;
exports.baseSizingXlarge = 56;
exports.baseSizing2xlarge = 64;
exports.actionSizingMini = 20;
exports.actionSizingTiny = 24;
exports.actionSizingXsmall = 32;
exports.actionSizingSmall = 40;
exports.actionSizingMedium = 48;
exports.actionSizingLarge = 56;
exports.controlSizingMini = 16;
exports.controlSizingTiny = 24;
exports.controlSizingXsmall = 32;
exports.controlSizingSmall = 40;
exports.controlSizingMedium = 48;
exports.controlSizingLarge = 56;
exports.sizingMini = 8;
exports.sizingTiny = 12;
exports.sizingXsmall = 16;
exports.sizingSmall = 20;
exports.sizingMedium = 24;
exports.sizingLarge = 32;
exports.sizingXlarge = 40;
exports.sizing2xlarge = 48;
exports.sizing3xlarge = 56;
exports.sizing4xlarge = 64;
exports.sizing5xlarge = 80;